import NaplanPreparation from '@/pages/programs/NaplanPreparation';
import { useLocation } from '@/contexts/LocationContext';
import { isNaplanState, SHARED_NAPLAN_PATH } from '@/config/naplanStates';

/** Shared NAPLAN route: renders the state template for the visitor's selected state (NSW by default). */
const NaplanProgram = () => {
  const { selectedState } = useLocation();
  const stateCode = isNaplanState(selectedState) ? selectedState : 'NSW';
  return <NaplanPreparation stateCode={stateCode} canonicalPath={SHARED_NAPLAN_PATH} />;
};

export default NaplanProgram;
